"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisputeStatus = exports.DisputeType = void 0;
var DisputeType;
(function (DisputeType) {
    DisputeType["INITIAL_ATTEMPT"] = "initial_attempt";
    DisputeType["MEDIATION"] = "mediation";
    DisputeType["ARBITRATION"] = "arbitration";
    DisputeType["LITIGATION"] = "litigation";
    // Resolution types (business-fe only — client-fe doesn't use these but they're part of the domain)
    DisputeType["MUTUAL_RESOLUTION"] = "mutual_resolution";
    DisputeType["FORMAL_RESOLUTION"] = "formal_resolution";
    DisputeType["FORMAL_RESOLUTION_WITH_PARTIAL_RELEASE"] = "formal_resolution_with_partial_release";
    DisputeType["FORMAL_RESOLUTION_WITH_REFUND"] = "formal_resolution_with_refund";
})(DisputeType || (exports.DisputeType = DisputeType = {}));
var DisputeStatus;
(function (DisputeStatus) {
    DisputeStatus["PENDING"] = "pending";
    DisputeStatus["REVIEW"] = "review";
    DisputeStatus["RESOLVED"] = "resolved";
    DisputeStatus["REJECTED"] = "rejected";
})(DisputeStatus || (exports.DisputeStatus = DisputeStatus = {}));
